const ratio = (number: number): number => number / (300 / 72)

export default ratio
